import { render, staticRenderFns } from "./SideSearch.vue?vue&type=template&id=5c53ca39&scoped=true&"
import script from "./SideSearch.vue?vue&type=script&lang=js&"
export * from "./SideSearch.vue?vue&type=script&lang=js&"
import style0 from "./SideSearch.vue?vue&type=style&index=0&id=5c53ca39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53ca39",
  null
  
)

export default component.exports